import remark from "remark";
import remarkHTML from "remark-html";

export const abstractHtml = (abstract: string) => {
    
    const htmlContents = remark()   // TODO: May have to check for external / internal links
  .use(remarkHTML)
  .processSync(abstract)
 return String(htmlContents)
}